import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import D1 from '../../components/ExcerciseTypes/Design/TypeIn'
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine'
const json = {
	1: {
		// Exercise num
		unit: 'Unit 2',
		id: '4WB-U2-P16-E1',
		audio: '',
		hideBtnFooter: true,
		// exerciseKey: 'img/FriendsPlus/Page7/Key/E1answerKey.png',
		component: T6,
		inputSize: 250,
		textAlign: 'center',
		maxLength: 18,

		titleQuestion: [
			{
				num: '1',
				title: 'Find and circle the words.',
				color: '#234090',
			},
		],
		questions: [
			{
				title: `	
       
            <div> <img style='width:22cm' src='img/FriendsPlus/Page16/E1/1.jpg' /> </div>
          `,
				answer: [''],
			},
		],
	},
	2: {
		// Exercise num
		unit: 'Unit 2',
		id: '4WB-U2-P16-E2',
		audio: '',
		exerciseKey: 'img/FriendsPlus/Page16/E2/Key/E2answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		component: T6,
		inputSize: 167,
		textAlign: 'center',
		maxLength: 30,
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',
			fontSize: 23,
			height: 22,
			width: 180,
		},
		titleQuestion: [
			{
				num: '2',
				title: 'Look and write.',
				color: '#234090',
			},
		],
		isHiddenCheck: true,
		questions: [
			{
				title: `
        <div style=" position: relative; ">
						<div> <img style='width:20cm' src='img/FriendsPlus/Page16/E2/1.jpg' /> </div>
            <div style="width:180px; position: absolute; top:169px; left: 285px; "><input id='0' ></input></div>
            <div style="width:180px; position: absolute; top:169px; left: 558px; "><input id='1' ></input></div>
            <div style="width:180px; position: absolute; top:402px; left: 65px; "><input id='2' ></input></div>
            <div style="width:180px; position: absolute; top:402px; left: 336px; "><input id='3' ></input></div>
						
					</div>
        
          
          `,
				answer: ['airport', 'store', 'police station', 'fire station'],
			},
		],
	},
}

export default json
